module.exports = __webpack_public_path__ + "static/fonts/notokr-bold.073dba1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/artistry/makeover/font/notokr-bold.woff2
// module id = aJCk
// module chunks = 0